import React, { useEffect } from "react";
import bgImg from "../images/Landing - Background.svg";
import mainImg from "../Home/main.svg"; 

function LandingPage({ onApplyClick }) {
  useEffect(() => {
    const initAOS = async () => {
      const AOS = (await import('https://cdn.jsdelivr.net/npm/aos@2.3.4/dist/aos.js')).default;
      AOS.init({ duration: 1000, once: true });
    };
    initAOS();
    
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/aos@2.3.4/dist/aos.css';
    document.head.appendChild(link);
  }, []);

  return (
    <div
      className="
        relative min-h-screen w-full z-20 flex flex-col 
        items-center justify-start text-white text-center 
        overflow-hidden bg-cover bg-center bg-no-repeat
        -mt-16 sm:-mt-20 md:-mt-2 
      "
      style={{
        backgroundImage: "url('/images/bg-2.png')",
      }}
    >
      {/* Content Container */}
      {/* FIX: Reduced padding (pt) so it doesn't start too low on laptops */}
      <div className="w-full flex flex-col items-center justify-center flex-1 px-4 sm:px-6 md:px-8 lg:px-12 pt-15 sm:pt-24 md:pt-28 lg:pt-32 2xl:pt-48 pb-0">
        
        {/* Header Section */}
        <div className="relative z-10 w-full max-w-md sm:max-w-lg md:max-w-2xl lg:max-w-4xl mb-2 sm:mb-3 md:mb-4" data-aos="fade-up">
          {/* FIX: Toned down text sizes for lg (laptop) */}
          {/* Changed lg:text-6xl to lg:text-5xl. The huge 7xl is now saved for xl/2xl screens only */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-5xl xl:text-6xl 2xl:text-7xl leading-tight font-normal mb-3 sm:mb-4 md:mb-5">
            Call for <span className="font-bold">Incubatees</span>
          </h1>
          
          <p className="text-sm sm:text-base md:text-lg lg:text-xl text-white/90 px-4 sm:px-6 md:px-8 leading-relaxed mb-4 sm:mb-5 md:mb-6">
            Let's spark ideas and turn them into impactful realities!
          </p>
          
          <div className="inline-block text-xs sm:text-sm md:text-base font-medium bg-white/80 text-black px-5 sm:px-6 md:px-7 py-2 sm:py-2.5 rounded-full shadow-lg">
            Your Startup Journey Begins Here.
          </div>
        </div>

        {/* Main Illustration */}
        {/* FIX: Adjusted max-width so the image isn't too wide on laptops */}
        {/* Changed lg:max-w-4xl to lg:max-w-3xl. This keeps it contained on 13-14 inch screens */}
        <div 
          className="relative z-10 w-full max-w-sm sm:max-w-lg md:max-w-xl lg:max-w-3xl xl:max-w-5xl -mt-8 sm:-mt-12 md:-mt-16 lg:-mt-24 xl:-mt-32" 
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <img
            src={mainImg}
            alt="Main Illustration"
            className="w-full h-auto object-contain drop-shadow-2xl"
          />
        </div>
      </div>
    </div>
  );
}

export default LandingPage;